import { Component, OnInit, Input, Output, EventEmitter, ViewChild, ElementRef, AfterViewInit } from '@angular/core';
import { LookupService } from '../../services/lookup.service';
import { Observable } from 'rxjs';
import { debounceTime, distinctUntilChanged, switchMap, tap } from 'rxjs/operators';

@Component({
  selector: 'app-lookup-typeahead',
  templateUrl: './lookup-typeahead.component.html',
  styleUrls: ['./lookup-typeahead.component.scss']
})
export class LookupTypeaheadComponent implements OnInit {
  @Input() lookupType: string;
  @Input() controlName: string;
  @Output() setValue: EventEmitter<string> = new EventEmitter();
  @ViewChild('typeahead') typeaheadRef: ElementRef;
  valueSet: boolean;
  lookupTypeahead;
  searching: boolean;
  tempValue: string;

  constructor(private lookupService: LookupService) { }

  ngOnInit(): void {
    this.lookupTypeahead = (text: Observable<string>) => text.pipe(
      debounceTime(200),
      distinctUntilChanged(),
      tap(() => {
        if (this.typeaheadRef.nativeElement.value == '' || this.typeaheadRef.nativeElement.value == null) {
          this.searching = false;
        } else {
          this.searching = true;
        }
      }),
      switchMap(term => term.length < 2 ? []
        : this._determineLookup(this.lookupType, term)),
      tap(() => this.searching = false)
    )
  }

  _determineLookup(lookupType: string, term: string): Promise<string[]> {
    switch (lookupType) {
      case 'specialty':
        return this.lookupService.searchSpecialties(term);
      case 'condition':
        return this.lookupService.searchConditions(term);
    }
  }

  onItemSelected(value: any) {
    this.setValue.emit(value.item);
    this.valueSet = true;
    this.tempValue = value.item;
  }

  onFocusOut() {
    // setTimeout(() => {
    //   if (!this.valueSet) {
    //     this.setValue.emit(null);
    //     this.typeaheadRef.nativeElement.value = null;
    //   }
    // }, 200);
    this.setValue.emit(this.typeaheadRef.nativeElement.value);
    this.valueSet = true;
    this.tempValue = this.typeaheadRef.nativeElement.value;
  }

  onValueChanged(event: any) {
    if (this.tempValue === this.typeaheadRef.nativeElement.value) { return; }
    this.valueSet = false;
  }
}
